import React from 'react';
import PropTypes from 'prop-types';
import useStepClickHandler from '../hooks/useStepClickHandler';

const StepCta = ({ title, route, classNames = '', stepKey }) => {
	const isScrollToUDS = stepKey === 'payment';
	const onClickHandler = useStepClickHandler(route, title, isScrollToUDS);
	return (
		<button
			type="button"
			className={`btn btn-block btn-default ${classNames}`}
			onClick={onClickHandler}
		>
			{title}
		</button>
	);
};

StepCta.propTypes = {
	title: PropTypes.string.isRequired,
	route: PropTypes.string.isRequired,
	classNames: PropTypes.string,
	stepKey: PropTypes.string.isRequired
};

export default StepCta;
